import React from "react";

import {
	Alert,
	FormDatePicker,
	FormInputText,
	FormRadioButtons,
	FormSubscribe,
	usePyForm,
} from "@performyard/py-components";

import { GroupField } from "./GroupField";
import { LockReviewsField } from "./LockReviewsField";

import type { CycleType } from "../../Config";
import { AUTOMATION_TYPE_OPTIONS, AutomationType } from "./constants";

export { getSettingsDefaults, getSettingsSchema } from "./schema";

type CycleSettingsStepProps = {
	cycleType: CycleType;
	companyTimezone: string;
	defaultStartTime: number;
	defaultEndTime: number;
};

const ClearField = ({ id }: { id: string }) => {
	const form = usePyForm();
	React.useEffect(() => {
		form.setFieldValue(id, null);
	}, [form, id]);
	return null;
};

export const CycleSettingsStep = ({
	cycleType,
	companyTimezone,
	defaultStartTime,
	defaultEndTime,
}: CycleSettingsStepProps) => {
	return (
		<div className="flex flex-col gap-4">
			<FormInputText id="cycleName" label="Review Cycle Name" placeholder="Review cycle name" clearable />

			<LockReviewsField />

			{cycleType === "automated" && (
				<FormRadioButtons<AutomationType>
					id="automationType"
					label="Select an Automation Type"
					options={AUTOMATION_TYPE_OPTIONS}
				/>
			)}

			{cycleType === "group" && <GroupField />}

			<FormDatePicker
				id="startDate"
				label="Review Cycle Start Date"
				showTimeDropdown
				showMonthAndYearDropdowns
				defaultTime={defaultStartTime}
			/>

			{cycleType === "automated" && (
				<FormSubscribe
					id="automationType-subscribe"
					selector={(state) => state.values?.automationType as AutomationType | undefined}
				>
					{(automationType) =>
						automationType === "recurring" ? (
							<FormDatePicker
								id="automationEndDate"
								label="Automation End Date"
								showTimeDropdown
								showMonthAndYearDropdowns
								defaultTime={defaultEndTime}
							/>
						) : (
							<ClearField id="automationEndDate" />
						)
					}
				</FormSubscribe>
			)}

			<Alert type="neutral" message={`All times are set to your company timezone ${companyTimezone}`} />
		</div>
	);
};
